module.exports = __webpack_public_path__ + "static/media/slider-next.dd12b835.svg";